"use strict";
/*
 *
 *@description:弹窗模块
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-28 17:37:05
  *有登模态框 不要随意改动
 *
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dot_1 = __importDefault(require("dot"));
var tpl = require("./tpl.html");
require("./style.less");
// 
var Modal = /** @class */ (function () {
    function Modal(options) {
        var default_option = {
            content: "",
            modalClass: "",
            showclose: true,
            showtitle: true,
            title: null,
            onClose: null
        };
        this.options = $.extend(default_option, options);
    }
    //显示弹窗
    Modal.prototype.show = function (callback) {
        var _this = this;
        this.html = $(dot_1.default.template(tpl)(this.options));
        $(".modaldiv", this.html).append(this.options.content);
        if (this.options.showtitle && this.options.title) {
            $(".modaltitle", this.html).html(this.options.title);
        }
        $(".modal_close", this.html).click(function () {
            _this.close();
        });
        $('body').append(this.html).css({
            overflow: 'hidden' //无法滚动
        });
        //显示 fadeIn动画
        this.html.fadeIn(150, function () {
            callback && callback();
        });
        setTimeout(function () {
            _this.resize();
        }, 10);
    };
    //关闭弹窗
    Modal.prototype.close = function () {
        var _this = this;
        this.html.fadeOut(150, function () {
            _this.html.remove();
            if (_this.options.onClose) {
                _this.options.onClose();
            }
        });
        $('html').css({
            overflow: 'scroll'
        });
    };
    //调整弹窗
    Modal.prototype.resize = function () {
        var modalbody = $('.modalbody', this.html);
        var top = 0;
        var whei = $(window).height();
        var bodyHeight = modalbody.outerHeight();
        if (whei > bodyHeight) {
            top = (whei - bodyHeight) / 2 + 100;
        }
        modalbody.css({
            top: top,
            'margin-left': -(bodyHeight / 2)
        });
    };
    return Modal;
}());
exports.default = Modal;
//# sourceMappingURL=data:application/json;base64,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